import { Flame, Star } from "lucide-react";

export default function TestimonialsSection({ t }) {
  return (
    <>
      {/* Proof banner */}
      <section className="py-12 bg-[#CDA34F]/5 border-y border-[#CDA34F]/10" data-testid="proof-section">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <div className="flex items-center justify-center gap-3 mb-3">
            <Flame className="w-5 h-5 text-[#CDA34F]" />
            <h3 className="text-xl font-extrabold text-gray-900">{t.proof.title}</h3>
          </div>
          <p className="text-gray-600 mb-6">{t.proof.desc}</p>
          {t.proof.stats && (
            <div className="flex flex-wrap items-center justify-center gap-6 mt-4">
              {t.proof.stats.map((s, i) => (
                <div key={i} className="text-center">
                  <p className="text-2xl font-extrabold text-gray-900">{s.value}</p>
                  <p className="text-xs text-gray-500 uppercase tracking-wide mt-0.5">{s.label}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Testimonials grid */}
      <section id="testimonials" className="py-20 bg-gray-50" data-testid="testimonials-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">{t.testimonials.title}</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {t.testimonials.items.map((item, i) => (
              <div key={i} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
                <div className="flex gap-1 mb-4">
                  {Array(item.rating).fill(0).map((_, j) => (<Star key={j} className="w-5 h-5 text-yellow-400 fill-yellow-400" />))}
                </div>
                <p className="text-gray-600 mb-6 leading-relaxed">"{item.text}"</p>
                <div className="flex items-center gap-3">
                  <img src={item.photo} alt={item.name} className="w-12 h-12 rounded-full object-cover border-2 border-[#CDA34F]/20" />
                  <div>
                    <p className="font-bold text-gray-900">{item.name}</p>
                    <p className="text-sm text-gray-500">{item.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
